'use client';
import { usePathname } from 'next/navigation';

import { useTranslation } from '@/lib/i18n/i18n.client';

import { envDomain } from '@/constant/env';

import { SvgIcon } from '@/components/SvgIcon';

import { IconButton } from '@/components/atoms/IconButton';
import { Text } from '@/components/atoms/Text';

import ShareCopyLink from './ShareCopyLink';
import usePostShare from './usePostShare';

const ShareStrip = ({
  url: urlProp,
  title,
}: {
  url?: string;
  title: string;
}) => {
  const { texts } = useTranslation();

  const pathname = usePathname();
  const url = urlProp || `${envDomain}${pathname}`;
  const { displayedSocialShareOptions, shouldDisplayCopyButton } = usePostShare(
    {
      url,
      title,
      shareOptionsIds: ['linkedin', 'twitter-x', 'facebook', 'copy'],
    }
  );

  return (
    <div className='flex items-center md:gap-1 justify-center'>
      {/* prevnt from falling onto another line */}
      <Text
        variant='body-m'
        color='gray-500'
        classNames={{ wrapper: 'whitespace-nowrap' }}
      >
        {texts.blog.share_article}:
      </Text>

      {displayedSocialShareOptions.map(({ id, icon, label, url }) => (
        <IconButton
          key={id}
          color='secondary'
          variant='text'
          as='a'
          href={url}
          target='_blank'
          aria-label={label}
          size='s'
        >
          <SvgIcon src={icon} className='text-base-black h-4 w-4' />
        </IconButton>
      ))}
      {shouldDisplayCopyButton && <ShareCopyLink url={url} size='s' />}
    </div>
  );
};

export default ShareStrip;
